import Vue from 'vue';
import Vuex from 'vuex'
Vue.use(Vuex);
import  admin from './modules/admin';
import  navHide from './modules/navHide'
import  getters from './getter'

const store = new Vuex.Store({
  modules:{
    admin,
    navHide
  },
  getters
})
export default store
